import {connect} from 'react-redux'
import {changeViewing} from '../../../redux/modules/grandmaster'
import GrandmasterOnboardingCard from '../components/GrandmasterOnboardingCard'

const mapDispatchToProps = dispatch => ({
  dismissOnboarding: () => dispatch(changeViewing('practice'))
})

export default connect(
  null,
  mapDispatchToProps
)(GrandmasterOnboardingCard)



// WEBPACK FOOTER //
// ./src/domains/grandmaster/containers/VisibleGrandmasterOnboardingCard.js